import * as Yup from 'yup';

const schema = Yup.object().shape({
    "exercicio": Yup.string().required("Informe o exercício"),
    "autoria": Yup.string().required("Informe a autoria"),
    "funcao": Yup.string().required("Informe a função"),
    "valorPrevisto": Yup.number().required("Informe o valor previsto"),
    "valorRealizado": Yup.number().required("Informe o valor realizado"),
    "municipio": Yup.string().nullable(),
    "orgaoConcedente": Yup.string().nullable(),
    "documento": Yup.string().nullable(),
    "codigoUnicoSegregado": Yup.string().nullable(),
    "dataSolicitacaoEmenda": Yup.date().nullable(),
    "dataLiberacaoEmenda": Yup.date().nullable(),
    "dataInicioEmenda": Yup.date().nullable(),
    "dataFinalEmenda": Yup.date().nullable(),
    "dataInicioTermoAditivo": Yup.date().nullable(),
    "dataFinalTermoAditivo": Yup.date().nullable(),
    "fonteRecurso": Yup.string().nullable(),
    "codigoReceita": Yup.string().nullable(),
    "atosNormativos": Yup.string().nullable(),
    "instrumentoJuridico": Yup.string().nullable(),
    "informacoesComplementares": Yup.string().nullable(),
    "anotacoesComplementares": Yup.string().nullable(),
    "painelEmendaGovFederal": Yup.string().nullable(),
    "painelEmendaGovEstadual": Yup.string().nullable(),
});

export default schema;